import { MOBILE_SCREEN_WIDTH } from '@lib/view/hooks/screens';
import { useWindowSize } from '@lib/view/hooks/useWindowSize';
import React, { FC, useMemo } from 'react';

const SpinnerLoading: FC = () => {
    const { width } = useWindowSize();
    const mobile = useMemo(() => width < MOBILE_SCREEN_WIDTH, [width]);
    return (
        <div
            className={`fixed w-full h-full flex justify-center items-center top-0 left-0 bg-gray-300 z-999 text-tiktok-coral`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                className="animate-spin -ml-1"
                height={mobile ? 90 : 120}
                width={mobile ? 90 : 120}
            >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                />
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
            </svg>
        </div>
    );
};
export default SpinnerLoading;
